"use client";

import type { FC, ReactNode } from "react";
import { AppImage } from "@components/NextImage";
import { cn } from "utils";
import { AUTH_H5_LAYOUT, SIGN_IN_PAGE_ASSETS } from "../authLayoutTokens";
import { SignInHeadline } from "../shared/SignInHeadline";

interface SignInPageLayoutProps {
  children: ReactNode;
  className?: string;
}

/**
 * UI2 Sign in H5 扁平全页布局（Figma 96118:8347，D19）。
 * Logo + 标题区 + 表单区垂直居中，无 hero / bottom sheet。
 */
export const SignInPageLayout: FC<SignInPageLayoutProps> = ({
  children,
  className,
}) => (
  <div
    className={cn(
      "flex h-dvh w-full flex-col overflow-hidden bg-background_solid_neutral_secondary",
      AUTH_H5_LAYOUT.signInShellTopClass,
      className,
    )}
    data-dismiss-kbd-scope="1"
    data-testid="sign-in-page-layout"
  >
    <div className="flex min-h-0 flex-1 flex-col justify-center px-5">
      <div
        className="mx-auto flex w-full max-w-[353px] flex-col gap-8"
        data-testid="sign-in-content-column"
      >
        <header
          className="flex w-full max-w-[330px] flex-col items-start gap-[21px]"
          data-testid="sign-in-header"
        >
          <AppImage
            src={SIGN_IN_PAGE_ASSETS.logo}
            alt="EdWealth"
            width={60}
            height={32}
            loading="eager"
            className="h-8 w-auto shrink-0 self-start"
            data-testid="sign-in-brand-logo"
          />
          <SignInHeadline />
        </header>
        {children}
      </div>
    </div>
    <div
      className="shrink-0 pb-[max(24px,env(safe-area-inset-bottom,0px))]"
      aria-hidden
    />
  </div>
);
